/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} So_Status_AllocatedInputs */

const en_so_status_allocated = /** @type {(inputs: So_Status_AllocatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocated`)
};

/**
* | output |
* | --- |
* | "Allocated" |
*
* @param {So_Status_AllocatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const so_status_allocated = /** @type {((inputs?: So_Status_AllocatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<So_Status_AllocatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_so_status_allocated(inputs)
});